import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';

export type MakeContributorProps = {
  hasMultipleEmails?: boolean;
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
};

const MakeContributorModal: FC<MakeContributorProps> = ({
  isOpen,
  onDismiss,
  onSuccess,
  hasMultipleEmails,
}) => (
  <Modal
    description={
      <AppFormattedMessage
        id={
          hasMultipleEmails
            ? 'UPGRADING_STAKEHOLDER_WITH_MULTIPLE_EMAILS_TO_CONTRIBUTOR'
            : 'ARE_YOU_SURE_YOU_WANT_MAKE_CONTRIBUTOR'
        }
      />
    }
    dismissButtonContent={<AppFormattedMessage id="NO" />}
    isOpen={isOpen}
    onDismiss={onDismiss}
    onSuccess={onSuccess}
    successButtonClassName="bg-brand-700"
    successButtonContent={<AppFormattedMessage id="YES" />}
    title={<AppFormattedMessage id="MAKE_CONTRIBUTOR" />}
  />
);

export default MakeContributorModal;
